import { render, staticRenderFns } from "./index6.vue?vue&type=template&id=f451b0b2&scoped=true&"
import script from "./index6.vue?vue&type=script&lang=js&"
export * from "./index6.vue?vue&type=script&lang=js&"
import style0 from "./index6.vue?vue&type=style&index=0&id=f451b0b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f451b0b2",
  null
  
)

export default component.exports